export default __webpack_public_path__ + "static/media/supine.5c4a5d36.png";